import { createTracker } from 'usage-tracker';
export const tracker = createTracker({
  standalone: true
});
function getApp() {
  return window.location.pathname.split('/')[1];
}
export const trackInteraction = (interaction, approvalType, extra) => tracker.track('Product Approvals', 'Product Approvals Interaction', Object.assign({
  app: getApp(),
  interaction,
  type: approvalType
}, extra));